<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_528_1864)">
        <path d="M7.2001 13.6473C10.7399 13.6473 13.6094 10.7777 13.6094 7.23794C13.6094 3.69817 10.7399 0.828613 7.2001 0.828613C3.66033 0.828613 0.790771 3.69817 0.790771 7.23794C0.790771 10.7777 3.66033 13.6473 7.2001 13.6473Z" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.909 10.8348C8.39117 11.0813 7.81172 11.2192 7.20004 11.2192C5.00118 11.2192 3.21866 9.43667 3.21866 7.23781C3.21866 6.56639 3.38486 5.93379 3.67836 5.37891" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.2093 17.247L13.7319 13.7695" stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_528_1864">
        <rect width="18" height="18" fill="white"/>
        </clipPath>
        </defs>
    </svg>
</template>